import { z } from "zod";
import type { Color } from "../../config/colors/colors";
import { COLORS } from "../../config/colors/colors";

const color = z.string().refine((val) => COLORS.includes(val as Color));

export { color };
